export default "__VITE_ASSET__BEzzoPbw__"